'use strict';

var signValidateCtrl = [
    '$state', '$scope', '$uibModal', 'toast', 'Integration', "$sce",
    function ($state, $scope, $uibModal, toast, Integration, $sce) {
        var _this = this;
        this.model = this.model || undefined;
        this.image = undefined;
        
        this.openModal = function () {
            $uibModal.open({
                animation: true,
                templateUrl: 'directives/signValidateDirectiveModal.html',
                controller: [
                    "$uibModalInstance",
                    "toast",
                    "field",
                    "item",
                    "model",
                    "image",
                    "$timeout",
                    "Container",
                    "$http",
                    "$serverData",
                    function ($uibModalInstance, toast, field, item, model, image, $timeout, Container, $http, $serverData) {
                        var _this = this;
                        this.field = field;
                        this.item = item;
                        this.model = model;
                        this.image = undefined; // In case of editing mode, set this.image = image;
                        this.signaturePad = null;
                        this.isSaving = false;

                        // Init canvas
                        $timeout(function () {
                            let canvas = document.getElementById('signaturePad');
                            if (canvas && SignaturePad) {
                                let ratio = Math.max(window.devicePixelRatio || 1, 1);

                                function resizeCanvas() {
                                    let ratio = Math.max(window.devicePixelRatio || 1, 1);
                                    canvas.width = canvas.offsetWidth * ratio;
                                    canvas.height = canvas.offsetHeight * ratio;
                                    canvas.getContext("2d").scale(ratio, ratio);
                                }

                                resizeCanvas();

                                _this.signaturePad = new SignaturePad(canvas);
                                _this.signaturePad.minWidth = 1;
                                _this.signaturePad.maxWidth = 2;
                                _this.signaturePad.penColor = "rgba(0, 0, 0, 1)";

                                // For editing existing signature
                                if (_this.image) {
                                    let image = new Image();
                                    image.onload = function () {
                                        let ctx = canvas.getContext("2d");
                                        ctx.drawImage(image, 0, 0, canvas.width / ratio, canvas.height / ratio);
                                    };
                                    image.src = _this.image;
                                }
                            }
                        }, 0);

                        _this.isSignaturePadEmpty = function () {
                            return _this.signaturePad ? _this.signaturePad.isEmpty() : true;
                        };

                        this.acceptSignature = function () {
                            this.isSaving = true;
                            if (_this.signaturePad && !_this.signaturePad.isEmpty()) {

                                let canvas = document.getElementById('signaturePad');
                                let ctx = canvas.getContext("2d");

                                // Copiar la firma del canvas actual a uno nuevo con fondo blanco
                                let tempCanvas = document.createElement("canvas");
                                tempCanvas.width = canvas.width;
                                tempCanvas.height = canvas.height;
                                let tempCtx = tempCanvas.getContext("2d");
                                tempCtx.fillStyle = "#ffffff";
                                tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);
                                tempCtx.drawImage(canvas, 0, 0);
                                let signatureData = tempCanvas.toDataURL('image/jpeg');

                                // Convert to Blob
                                function dataURLToBlob(dataURL) {
                                    let byteString = atob(dataURL.split(',')[1]);
                                    let mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
                                    let ab = new ArrayBuffer(byteString.length);
                                    let ia = new Uint8Array(ab);
                                    for (let i = 0; i < byteString.length; i++) {
                                        ia[i] = byteString.charCodeAt(i);
                                    }
                                    return new Blob([ab], { type: mimeString });
                                }
                                let blob = dataURLToBlob(signatureData);

                                // Local Download
                                // let a = document.createElement('a');
                                // a.href = URL.createObjectURL(blob);
                                // a.download = 'firma.jpg';
                                // document.body.appendChild(a);
                                // a.click();
                                // document.body.removeChild(a);

                                // Upload Signature
                                let timestamp = new Date().getTime();
                                let fd = new FormData();
                                const hostApi = $serverData.server;
                                fd.append('file', blob, `sign-${item.id}-${timestamp}.jpg`);

                                $http.post(hostApi.concat('/containers/signatures/upload'), fd, {
                                    headers: { 'Content-Type': undefined },
                                    transformRequest: angular.identity
                                }).then(function (res) {
                                    let file = res.data.result.files.file[0]
                                    
                                    let fileUrl = `${hostApi}/containers/${file.container}/download/${file.name}`;
                                    
                                    $uibModalInstance.close({ signature: signatureData, fileUrl: fileUrl });
                                }, function (err) {
                                    console.error("Error al guardar firma", err);
                                    toast.error("Error al guardar firma.");
                                    this.isSaving = false;
                                });
                            } else {
                                toast.error("Por favor, dibuje su firma.");
                                this.isSaving = false;
                            }
                        };


                        this.clearSignature = function () {
                            if (_this.signaturePad) {
                                _this.signaturePad.clear();
                            }
                        };
                        
                        this.close = function () {
                            $uibModalInstance.dismiss();
                        };
                    },
                ],
                controllerAs: "ctrl",
                size: "xlg",
                windowClass: "dialog",
                bindToController: true,
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    field: () => _this.field,
                    item: () => _this.item,
                    model: () => _this.model,
                    image: () => _this.image,
                }
            }).result.then((result) => {
                if (result && result.signature && result.fileUrl) {
                    _this.image = result.signature;
                    _this.model = result.fileUrl;
                    toast.success("Firma aceptada.");
                    // console.log('firma guardada en model', _this.model);
                } else {
                    toast.error("No se pudo aceptar la firma.");
                }
            }, function () { //dismiss
            });
        };
    }];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            field: '=',
            item: '=',
            model: '='
        },
        controller: signValidateCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'directives/signValidateDirective.html'
    };
};
